import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["document", "className"];

var _renderMark, _renderNode;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useContext } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import classNames from 'classnames';
export { BLOCKS } from '@contentful/rich-text-types';
import { convertTextToId } from '@miro-site/utils-rich-text';
import { Typography, Image } from '../../components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getIdFromHeadline = function getIdFromHeadline(val) {
  var _val, _val$props;

  val = Array.isArray(val) ? val[0] : val; // ! where is this coming from 🤔

  if ((_val = val) !== null && _val !== void 0 && (_val$props = _val['props']) !== null && _val$props !== void 0 && _val$props.children) {
    var _val2;

    return getIdFromHeadline((_val2 = val) === null || _val2 === void 0 ? void 0 : _val2['props'].children);
  }

  return convertTextToId(val);
};

var RichTextOptionsContext = /*#__PURE__*/createContext(null);
export var RichTextOptionsProvider = function RichTextOptionsProvider(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      children = _ref.children;
  var renderNode = options.renderNode,
      renderMark = options.renderMark;
  var renderOptions = {
    renderNode: _objectSpread(_objectSpread({}, defaultRenderOptions.renderNode), renderNode),
    renderMark: _objectSpread(_objectSpread({}, defaultRenderOptions.renderMark), renderMark)
  };
  return /*#__PURE__*/_jsx(RichTextOptionsContext.Provider, {
    value: renderOptions,
    children: children
  });
};
var defaultRenderOptions = {
  renderMark: (_renderMark = {}, _defineProperty(_renderMark, MARKS.BOLD, function (text) {
    return /*#__PURE__*/_jsx("strong", {
      children: text
    });
  }), _defineProperty(_renderMark, MARKS.ITALIC, function (text) {
    return /*#__PURE__*/_jsx("em", {
      children: text
    });
  }), _defineProperty(_renderMark, MARKS.UNDERLINE, function (text) {
    return /*#__PURE__*/_jsx("u", {
      children: text
    });
  }), _renderMark),
  renderNode: (_renderNode = {}, _defineProperty(_renderNode, BLOCKS.HEADING_2, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      id: getIdFromHeadline(children),
      type: "heading-2",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_3, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      id: getIdFromHeadline(children),
      type: "heading-3",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_4, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      className: "mb-200 mb-lg-300",
      type: "heading-4",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_5, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      className: "mb-200 mb-lg-300",
      type: "sub-heading-1",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_6, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      className: "mb-200 mb-lg-300",
      type: "sub-heading-2",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.PARAGRAPH, function (node, children) {
    if (Array.isArray(children) && children.join('').trim().length === 0) {
      /**
       * Handle empty items
       */
      return null;
    }

    return /*#__PURE__*/_jsx(Typography, {
      type: "body-text-1",
      color: "secondary",
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.OL_LIST, function (node, children) {
    return /*#__PURE__*/_jsx("ol", {
      className: "list-unstyled",
      children: React.Children.map(children, function (child) {
        return /*#__PURE__*/_jsx("li", _objectSpread({}, child.props));
      })
    });
  }), _defineProperty(_renderNode, BLOCKS.UL_LIST, function (node, children) {
    return /*#__PURE__*/_jsx("ul", {
      className: "list-unstyled",
      children: React.Children.map(children, function (child) {
        return /*#__PURE__*/_jsx("li", _objectSpread({}, child.props));
      })
    });
  }), _defineProperty(_renderNode, INLINES.HYPERLINK, function (node, children) {
    return /*#__PURE__*/_jsx(Typography, {
      as: "a",
      href: node.data['uri'],
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.EMBEDDED_ASSET, function (node) {
    var _node$data, _node$data$target;

    var _ref2 = (node === null || node === void 0 ? void 0 : (_node$data = node.data) === null || _node$data === void 0 ? void 0 : (_node$data$target = _node$data.target) === null || _node$data$target === void 0 ? void 0 : _node$data$target.fields) || {},
        file = _ref2.file,
        description = _ref2.description;

    if (!file) {
      return null;
    }

    var content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Image, {
        className: "mb-100",
        image: {
          src: file.url,
          width: file.details.image.width,
          height: file.details.image.height
        }
      }), /*#__PURE__*/_jsx(Typography, {
        children: description
      })]
    });

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "d-block d-sm-none bg-info px-300 pt-300 pb-200 my-400 ms-n300 me-n300 ms-sm-0 me-sm-0",
        children: content
      }), /*#__PURE__*/_jsx("div", {
        className: "d-none d-sm-block bg-info rounded-1 px-300 pt-300 pb-200 my-400 my-lg-800 mb-xl-600 mt-xl-600",
        children: content
      })]
    });
  }), _renderNode)
};

var RichTextRenderer = function RichTextRenderer(_ref3) {
  var document = _ref3.document,
      className = _ref3.className,
      props = _objectWithoutProperties(_ref3, _excluded);

  var optionsContext = useContext(RichTextOptionsContext);
  var renderOptions = optionsContext || defaultRenderOptions;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    "data-testid": "rich-text-renderer",
    className: classNames(className, 'rich-text-renderer')
  }, props), {}, {
    children: documentToReactComponents(document, renderOptions)
  }));
};

export default RichTextRenderer;